"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModeStateTypeSchema = exports.ModeStateType = void 0;
const zod_1 = require("zod");
var ModeStateType;
(function (ModeStateType) {
    ModeStateType["Indeterminate"] = "indeterminate";
    ModeStateType["LogicLow"] = "logic-low";
    ModeStateType["LogicHigh"] = "logic-high";
})(ModeStateType || (exports.ModeStateType = ModeStateType = {}));
exports.ModeStateTypeSchema = zod_1.z.nativeEnum(ModeStateType);
//# sourceMappingURL=ModeStateType.js.map